exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".nts-modal .modal-body{width:100%}.nts-modal .modal-backdrop{width:100%}.nts-modal .modal.dialog{margin-bottom:10%}.nts-modal .margtop-5{margin-top:5px}", ""]);

